/**
 * Serve screen layout facts shared by the page, its headers, the student view
 * and the skeleton (PROD-1278 team review, Sep 14).
 *
 * On a 30-inch monitor the serve line stretched edge to edge: the X far left,
 * Finish far right, every student row a metre wide (Hunter). Yost: "just like
 * an 1100 pixel max width, kind of center it." So every SINGLE-COLUMN block of
 * the screen (the top bar's content, the search, the rows, the student view's
 * header, body and bottom bar) sits in one centered box capped at 1100px that
 * carries its own side inset. Tablet mode's two-column layout (the on-screen
 * keyboard beside the rows) stays full width: it needs the room.
 */
export const SERVE_CONTENT_WIDTH_CLASS = 'mx-auto w-full max-w-[1100px]'
